import axios from 'axios';
import config from 'api/urls-config.json';

export const getResources = params => {
    return axios.get(`${config.API + config.pages.resources}`, { params });
};
